import { useMemo, useState } from 'react';
import { CustomAction, Definition, Step, Uid } from 'sequential-workflow-designer';
import { CounterBadgeProExtension } from '@nocode-js/sequential-workflow-designer-pro';
import { SequentialWorkflowDesigner, useSequentialWorkflowDesignerController, wrapDefinition } from 'sequential-workflow-designer-react';

function createTaskStep(): Step {
	return {
		id: Uid.next(),
		componentType: 'task',
		type: 'task',
		name: 'Test',
		properties: {}
	};
}

const startDefinition: Definition = {
	sequence: [createTaskStep(), createTaskStep(), createTaskStep(), createTaskStep()],
	properties: {}
};

export function Badges() {
	const controller = useSequentialWorkflowDesignerController();
	const [definition, setDefinition] = useState(() => wrapDefinition(startDefinition));
	const [customActionPayload, setCustomActionPayload] = useState<string | null>(null);

	const extensions = useMemo(
		() => [
			CounterBadgeProExtension.create({
				getValue: () => {
					const value = Math.round(Math.random() * 100);
					return value > 20 ? `${value}` : null;
				},
				isClickable: true
			})
		],
		[]
	);

	function customActionHandler(action: CustomAction, step: Step | null) {
		if (step) {
			setCustomActionPayload(`${action.type}, step: ${step.id}}`);
		}
	}

	return (
		<div className="page" data-testid="badges">
			<h2>Badges</h2>

			<div className="control">
				<button onClick={controller.updateBadges} className="btn">
					Update badges
				</button>
			</div>

			<SequentialWorkflowDesigner
				undoStackSize={10}
				definition={definition}
				onDefinitionChange={setDefinition}
				toolboxConfiguration={false}
				stepsConfiguration={{}}
				controlBar={false}
				rootEditor={false}
				stepEditor={false}
				extensions={extensions}
				customActionHandler={customActionHandler}
				controller={controller}
			/>

			<pre>{customActionPayload}</pre>
		</div>
	);
}
